// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"6471f008","486":"21a4de0a","779":"e6c35ebb"}[chunkId] + ".chunk.js";
};